const API_BASE = "https://admin.bookvenue.app/api";

async function post(path, body, token) {
  const res = await fetch(`${API_BASE}${path}`, {
    method: "POST",
    headers: {
      Accept: "application/json",
      "Content-Type": "application/json",
      ...(token ? { Authorization: `Bearer ${token}` } : {}),
    },
    body: JSON.stringify(body),
  });
  const json = await res.json().catch(() => ({}));
  if (!res.ok || json.success === false) {
    throw new Error(json.message || `Request failed (${res.status})`);
  }
  return json;
}

// ⚠️ confirm this endpoint URL
export const createHotelBooking = (payload, token) =>
  post("/hotels/bookings", payload, token);

export const verifyHotelPayment = (payload, token) =>
  post("/hotels/bookings/verify", payload, token);

// Loads Razorpay's checkout script once, only when it's needed
export const loadRazorpay = () =>
  new Promise((resolve) => {
    if (window.Razorpay) return resolve(true);
    const s = document.createElement("script");
    s.src = "https://checkout.razorpay.com/v1/checkout.js";
    s.onload = () => resolve(true);
    s.onerror = () => resolve(false);
    document.body.appendChild(s);
  });

// Formats a date as "2026-11-07" in local time.
// Don't use toISOString(): it converts to UTC, and in IST that shifts dates back a day.
export const toYMD = (d) => {
  const x = new Date(d);
  return `${x.getFullYear()}-${String(x.getMonth() + 1).padStart(2, "0")}-${String(
    x.getDate(),
  ).padStart(2, "0")}`;
};
